'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'face-zipper';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e3a5';
var svgPathData = ['M32.1 256c0 141.4 114.6 256 256 256 32.2 0 63-5.9 91.3-16.8l-6.7-6.7c-26.7-26.7-30.6-67.5-11.7-98.3-2.8 1.1-5.8 1.7-9 1.7-13.3 0-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32c0 1.6-.1 3.1-.4 4.5l31.9-31.9c31.2-31.2 81.9-31.2 113.1 0l6.7 6.7c10.8-28.4 16.8-59.2 16.8-91.3 0-141.4-114.6-256-256-256s-256 114.6-256 256zm136 80c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32zm72-128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm8 128c0-13.3 10.7-24 24-24s24 10.7 24 24l0 32c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-32zm152-128a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M240.1 208a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm136 216l-49.4-49.4c-12.5-12.5-32.8-12.5-45.3 0l-34.7 34.7c-12.5 12.5-12.5 32.8 0 45.3L456.1 504c22.1 22.1 57.9 22.1 80 0s22.1-57.9 0-80zm-56 40a16 16 0 1 1 32 0 16 16 0 1 1 -32 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFaceZipper = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;